<script>
  export let map;
  export let live = false;
</script>

<div class="map-score nes-container is-rounded" on:click>
  <slot name="header"></slot>

  <div class="map {map.difficulty}" class:pulse={live}>
    <img class="nes-avatar is-rounded is-medium" alt=""
         src={map.cover_url}
         style="image-rendering: pixelated;"
    />

    <span>{map.name} / {map.author_name} / {map.level_author}</span>
  </div>

  <slot name="footer"></slot>
</div>

<style>
    .map-score {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 1rem;
        color: #222;
        background-color: #aaa;
        padding: .5rem;
    }

    .map-score:last-child {
        margin-bottom: .5rem;
    }

    .map-score > :global(*) {
        width: max-content;
        max-width: 100%;
        margin-right: .5rem;
    }

    .map {
        display: inline-flex;
        align-items: center;
        flex-grow: 1;
    }

    .map img {
        margin-right: .5rem;
    }

    .map.easy {
        color: MediumSeaGreen;
    }

    .map.normal {
        color: #59b0f4;
    }

    .map.hard {
        color: tomato;
    }

    .map.expert {
        color: #bf2a42;
    }

    .map.expertPlus {
        color: #8f48db;
    }

    @media screen and (max-width: 767px) {
        .map-score {
            flex-direction: column;
        }
    }
</style>